import React from "react";
import { useSelector } from "react-redux";
import Joblist from "../components/Joblist/Joblist";
import SalarySortFilter from "../components/SalarySortFilter/SalarySortFilter";
import SearchFilter from "../components/SearchFilter/SearchFilter";

function Home() {
    
  const status = useSelector((state) => state.jobs);
  const { jobsCategory } = status;
  return (
    <>
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="lws-section-title">All {jobsCategory==="all"? "Available":jobsCategory==="internship"? "Internship":jobsCategory==="fullTime"? "Full Time":jobsCategory==="remote"? "Remote":""} Jobs</h1>
        <div className="flex gap-4">
          <SearchFilter />
          <SalarySortFilter />
        </div>
      </div>
      <Joblist />
    </>
  );
}

export default Home;
